import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface AskAssistantResponse {
  answer: string;
}

@Injectable()
export class AssistantService {
  constructor(private http: HttpClient) {}

  ask(question: string, screen?: string | null) {
    return this.http.post<AskAssistantResponse>(environment.api + '/assistant/ask', {
      question,
      screen: screen ?? null,
    });
  }
}
